import React, { useCallback } from 'react';

import { Col, Row } from 'react-bootstrap';

import { CheckboxField } from './edit_blocks';

const channelMap = {
    vkplay: {
        label: 'VK Play Игры',
        slug: 'vkplay',
        id: 36,
    },
    cybersport: {
        label: 'VK Play Киберспорт',
        slug: 'cybersport',
        id: 35,
    },
    hard: {
        label: 'Железо и софт',
        slug: 'hard',
        id: 60,
    },
    industry: {
        label: 'Индустрия',
        slug: 'industry',
        id: 33,
    },
    lifestyle: {
        label: 'Лайфстайл',
        slug: 'lifestyle',
        id: 43,
    },
    isPartner: {
        label: 'Партнерский материал',
        slug: 'is-partner',
        id: 32,
    },
    noGoogleNews: {
        label: 'Скрыть в Google News',
        slug: 'no-googlenews',
        id: 31,
    },
    noPulse: {
        label: 'Скрыть в Pulse',
        slug: 'no-pulse',
        id: 30,
    },
    noZen: {
        label: 'Скрыть в Zen',
        slug: 'no-zen',
        id: 29,
    },
    plus18: {
        label: '18+',
        slug: '18plus',
        id: 17,
    },
    evergreen: {
        label: 'Evergreen',
        slug: 'evergreen',
        id: 34,
    },
};

export default function ChannelsCheckboxes({ channels, storyType, onChange }) {
    const isCheckedById = useCallback((id) => (!!channels?.find((channel) => channel.slug === channelMap[id].slug)), [channels]);

    function handleChange(e) {
        const { checked, dataset: { type } } = e.currentTarget;

        let newChannels;

        if (checked) {
            let filteredChannels = channels;

            if (type === 'vkplay') {
                filteredChannels = channels.filter((channel) => channel.slug !== 'cybersport');
            } else if (type === 'cybersport') {
                filteredChannels = channels.filter((channel) => channel.slug !== 'vkplay');
            }

            newChannels = [
                ...filteredChannels,
                channelMap[type],
            ];
        } else {
            newChannels = channels.filter((channel) => channel.slug !== channelMap[type].slug);
        }

        onChange({
            currentTarget: {
                id: 'channels',
                type: 'channels',
                value: newChannels,
            },
        });
    }

    return (
        <div>
            <p className="form-label"><b>Каналы дистрибьюции</b></p>
            <Col>
                {Object.keys(channelMap).map((item) => (
                    <Row key={item}>
                        <CheckboxField
                            name={channelMap[item].slug}
                            label={channelMap[item].label}
                            value={isCheckedById(item)}
                            data-type={item}
                            onChange={handleChange}
                            // disabled={(item === 'cybersport' && isCheckedById('vkplay')) || (item === 'vkplay' && isCheckedById('cybersport'))}
                        />
                    </Row>
                ))}
            </Col>
        </div>
    );
}
